import { Button, CircularProgress, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import * as XLSX from "xlsx";
import useAdminData from "../../Queries/adminDataQuery";
import { useCallback } from "react";
import { useBoundStore } from "useStore";

export default function ExportButton({ countryId, isLoading }) {
  const selectedStatus = useBoundStore((state) => state.soTallerSelectedStatus);

  const exportQuery = useAdminData({
    countryId,
    fullData: true,
    stateOverride: selectedStatus?.id,
    enabled: false,
  });

  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Datos");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const handleExport = useCallback(async () => {
    const result = await exportQuery.refetch();
    if (result.data?.data?.length) {
      exportToExcel(
        result.data.data,
        `Taller ${new Date().toISOString().slice(0, 10)}`,
      );
    }
  }, [exportQuery]);

  return (
    <Tooltip title="Exportar" placement="bottom" arrow>
      <span>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#002878",
            "&:hover": { backgroundColor: "#002878" },
          }}
          onClick={handleExport}
          disabled={exportQuery.isFetching}
        >
          {exportQuery.isFetching ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            <FileDownloadOutlinedIcon sx={{ width: 30, height: 30 }} />
          )}
        </Button>
      </span>
    </Tooltip>
  );
}
